export default function SectionHeader({ eyebrow, title, text, center = true }) {
  return (
    <div className={`${center ? "text-center mx-auto" : ""} section-header`}>
      <span className="eyebrow">{eyebrow}</span>
      <h2>{title}</h2>
      {text && <p>{text}</p>}
    </div>
  );
}
